import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-fast-order',
  templateUrl: './fast-order.component.html',
  styleUrls: ['./fast-order.component.scss'],
})
export class FastOrderComponent implements OnInit {
  games: any = [];
  selectedProds: any = [];
  private debounceTimer: any;

  constructor(public api: ApiService) {}

  ngOnInit(): void {
    this.games = this.api.games
      .filter((item) => {
        if (item.idInCart) {
          let gameInCart = this.api.order.prods.find(
            (item2) => item2.id === item.idInCart
          );
          if (gameInCart) {
            item.qtyInCart = gameInCart.quantity;
            if(this.api.fastOrderQty[item.Id])
              this.api.fastOrderQty[item.Id].qtyInCart = gameInCart.quantity;
          }
        } else {
          item.qtyInCart = 0;
        }

        ///rajouter 1 et z pour forcer le tri
        if (item.PriceListId && this.api.reducsDetails[item.PriceListId]) {
          if (
            !this.api.user ||
            !this.api.user.conditions ||
            this.api.user.conditions.offerEbp_excluded
              .split(',')
              .indexOf(item.PriceListId) === -1
          ) {
            item.offer_name =
              this.api.reducsDetails[item.PriceListId].Description;
            item.groupField = '1|' + item.offer_name;
          }
        } else {
          if (['FAR00098', 'FAR00099', 'FAR00100'].indexOf(item.familyId) > -1)
            item.groupField = 'z|' + item.name_editor;
          else item.groupField = item.name_editor;
        }

        if (item.groupField === undefined) {
          item.groupField = item.family;
        }

        if (item.groupField === null) {
          console.log(item);
        }

        if (this.api.adminOrder) return true;

        if (item.orderable != true) return false;
        if (item.active != '1') return false;
        if (item.ItemType != '0') return false;
        return true;
      })
      .sort((a, b) => a.groupField.localeCompare(b.groupField));
  }

  customSort(event) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result: number = 0;

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });
  }

  // changeQty(e, row) {
  //   // Annuler le timer précédent s'il existe
  //   if (this.debounceTimer) {
  //     clearTimeout(this.debounceTimer);
  //   }

  //   // Créer un nouveau timer avec un délai de 500ms
  //   this.debounceTimer = setTimeout(() => {
  //     let gameInCart = this.api.order.prods.find(
  //       (item) => item.id === row.idInCart
  //     );
  //     if (!gameInCart) {
  //       if (e.value > 0 && row.ItemType == '0') {
  //         this.api.addToCart(row);
  //       }
  //       if (e.value > 0 && row.ItemType == '1') {
  //         let offer = this.api.ebpOffers.find((item) => item.Id == row.Id);
  //         if (offer) {
  //           this.api.addEbpOffer(offer);
  //         } else {
  //           this.api.addToCart(row);
  //         }
  //       }
  //     } else {
  //       gameInCart.quantity = row.qtyInCart = e.value;
  //       this.api.changeQty(gameInCart);
  //     }
  //   }, 500);
  // }

  changeQty(e, row) {
    console.log(row);
    this.api.fastOrderQty[row.Id] = row;
  }
}
